module.exports = __webpack_public_path__ + "static/media/air-cargo-freight-boeing-777-300-er-aircraft.053ce981.jpeg";